module.exports = __webpack_public_path__ + "img/coming-soon-M.fd5fa9aa.jpg";